var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.componentKey,staticClass:"container v-content-container tooltip-wrapper popup-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',[_c('i',{staticClass:"fa fa-user fa-fw fa-list-alt"}),_vm._v(" "+_vm._s(_vm.$label("event.instructors", "Instructors"))+" "),_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
            content: _vm.$label('event.new_instructor', 'New instructor'),
            classes: 'custom-tooltip'
          }),expression:"{\n            content: $label('event.new_instructor', 'New instructor'),\n            classes: 'custom-tooltip'\n          }"}],staticClass:"btn btn-v-lightgreen-white pull-right",attrs:{"to":{ name: 'NewEventInstructor' }}},[_c('i',{staticClass:"fa fa-fw fa-lg fa-plus"})])],1)])]),_c('navigation-tabs'),_vm._m(0),_c('alert-box',{directives:[{name:"show",rawName:"v-show",value:(_vm.failedRequest),expression:"failedRequest"}],attrs:{"type":"warning","closeable":false,"show-icon":false}},[_vm._v(" "+_vm._s(_vm.$label( "event.instructors_failed_request", "Request failed while loading instructors." ))+" ")]),_c('Table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.failedRequest),expression:"!failedRequest"}],attrs:{"id":"instructors-table","loading":_vm.loading,"columns":[
      {
        title: 'Name',
        field: 'name',
        id: function (row) { return ("instructor-name-" + (row.id)); }
      },
      {
        title: 'Email',
        field: 'email',
        id: function (row) { return ("instructor-email-" + (row.id)); }
      },
      {
        title: 'Phone number',
        id: function (row) { return ("instructor-phone-number-" + (row.id)); },
        tooltip: function (row) { return '<div class="tooltip-title-background"><p class="tooltip-title"><i class="text-primary fa fa-lg fa-fw fa-user"></i> <b>' +
          (Boolean(row.first_name && row.first_name)
            ? _vm.beautifyName(row.first_name, row.first_name)
            : '') +
          '</b></p></div>' +
          '<i class="text-v-green fa  fa-lg fa-fw fa-mobile"></i>' +
          (Boolean(
            row.phone_number &&
              row.phone_number.prefix &&
              row.phone_number.number
          )
            ? ("+" + (row.phone_number.prefix) + (row.phone_number.number))
            : '') +
          '<br><i class="text-v-green fa fa-lg fa-fw fa-phone"></i> <br><i class="text-v-green fa fa-lg fa-fw fa-tag"></i> '; },
        icon: function (row) { return Boolean(
            row.phone_number &&
              row.phone_number.prefix &&
              row.phone_number.number
          )
            ? 'mobile'
            : null; },
        value: function (row) { return Boolean(
            row.phone_number &&
              row.phone_number.prefix &&
              row.phone_number.number
          )
            ? ("+" + (row.phone_number.prefix) + (row.phone_number.number))
            : '-'; }
      },
      {
        title: 'Categories',
        id: function (row) { return ("instructor-categories-" + (row.id)); },
        value: function (row) { return _vm.getCategoryNames(row.categories); }
      }
    ],"actions":[
      {
        type: 'detail',
        onClick: function (row) {
          _vm.$router.push({
            name: 'EventInstructorDetails',
            params: { instructor_id: row.id }
          });
        }
      },
      {
        type: 'delete',
        id: function (row) { return ("delete-instructor-button-" + (row.id)); },
        onClick: function (row) { return _vm.deleteInstructor(row.id); }
      }
    ],"data":_vm.instructors,"meta":_vm.metaData},on:{"fetchQuery":function (params) {
        _vm.fetchParams = params;
        _vm.getInstructors({
          //
        });
      }}},[_c('div',{staticClass:"btn-group",staticStyle:{"margin-left":"5px"},attrs:{"slot":"toolbar","id":"action-dropdown"},slot:"toolbar"},[_c('button',{staticClass:"btn btn-primary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "+_vm._s(_vm.$label("common.actions", "Actions"))+" "),_c('span',{staticClass:"caret"})]),_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'NewEventInstructor' }}},[_c('i',{staticClass:"text-primary fa fa-fw fa-lg fa-plus"}),_vm._v(" "+_vm._s(_vm.$label("event.new_instructor", "New instructor")))])],1)])])]),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-8"},[_c('div',{staticClass:"col-xs-12"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-8"},[_c('div',{staticClass:"col-xs-12"})])}]

export { render, staticRenderFns }